import { hybris } from './hybris.repository';
import { donation } from './donation.repository';
import { custex } from './custex.repository';
import { logistics } from './logistics.repository';
import { account } from './account.repository';
import { google } from './google.repository';
import { exponea } from './exponea.repository';
import { reservation } from './reservation.repository';
import { olapic } from './olapic.repository';
import { logs } from './logs.repository';
import { rabbit } from './rabbit.repository';
import { payment } from './payment.repository';
import { ifcConfig } from './ifcConfig.repository';

export const api = Object.freeze({
    account,
    custex,
    hybris,
    donation,
    logistics,
    google,
    exponea,
    reservation,
    olapic,
    logs,
    rabbit,
    payment,
    ifcConfig
});